import React, { useState } from 'react';
import { Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { searchSelector } from '../../store/selectors';
import { setSearch } from '../../store/actions';
import { notificationConstants } from '../../../../constants/notification.constants';
import styles from './Search.module.scss';

const { Search: InputSearch } = Input;

const Search = () => {
  const search = useSelector(searchSelector);
  const [localSearch, setLocalSearch] = useState(search);

  const dispatch = useDispatch();

  const handleChange = (e) => setLocalSearch(e.target.value);

  const handleSearch = (value) => {
    dispatch({
      type: notificationConstants.NOTIFICATION_CLEAR,
      payload: null,
    });
    dispatch(setSearch(value));
  };

  return (
    <InputSearch
      className={styles.root}
      placeholder="Найти"
      value={localSearch}
      onSearch={handleSearch}
      onChange={handleChange}
      enterButton
    />
  );
};

export default Search;
